import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { AuthService } from 'src/app/shared/services/http/auth/auth.service';

@Component({
  selector: 'app-delete-modal',
  templateUrl: './delete-modal.component.html',
  styleUrls: ['./delete-modal.component.scss']
})
export class DeleteModalComponent {
  constructor(public dialogRef: MatDialogRef<DeleteModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: AuthService) {
    console.log('data', data);

  }
  ngOnInit() {

  }
  schoolId: any;


  closeModal() {
    this.dialogRef.close({
      match: true,
    })
  }

  deleteSchool() {
    const data = {
      id: this.data.result
    }
    this.service.deleteStudentData(data).subscribe(res => {
      this.dialogRef.close({
        match: true,
      })
    })

  }
}
